import { Component, OnInit, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Subscription } from "rxjs/internal/Subscription";
import { OPD_CONST } from "../../properties/opd-static-properties";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { MergePatientService } from "../../services/Smerge-patient.service";
import { SearchHeaderService } from "../../services/SsearchHeader.service";
import { PatientBlockAddComponent } from "../patient-blocking/patient-block-add/patient-block-add.component";
import { FormControl } from "@angular/forms";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { SearchService } from "projects/lib/medcare-core-lib/src/lib/services/search.service";
import { DatePipe } from "@angular/common";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";
import { Langauge } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
import { ConfirmDynamicDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/confirm-dynamic-dialog/confirm-dynamic-dialog.component";
@Component({
  selector: "app-patient-merge",
  templateUrl: "./patient-merge.component.html",
  styleUrls: ["./patient-merge.component.scss"],
  providers: [DatePipe],
})
export class PatientMergeComponent implements OnInit, OnDestroy {
  searchCriteria: any = null;
  patientList: any[] = [];
  refreshTime: string = "";
  hidePatientSearch = false;
  patientInfoDisplay: string = "";
  selectedPatient: any = null;
  private subscriptionList = new Subscription();
  displayedColumns: any[] = OPD_CONST.displayColumnMerge;
  dataSource = new MatTableDataSource<any>();
  alldata: any = [];
  reasonSample: any[] = [];
  reason: string;
  remarks: string;
  reasonList: any[]=[];
  reasonSearch: FormControl = new FormControl();
  langaugeValue:string="";
  formattedDate:string="";

  constructor(
    private searchService: SearchService,
    public searchHead: SearchHeaderService,
    public dialog: MatDialog,
    public mergeService: MergePatientService,
    public generalApiService: GeneralUrlService,
    public snackBar: MatSnackBar,
    private langService: MultiLanguageService,
    public appBaseService: AppBaseService,
    private datepipe: DatePipe,
    private thConvertService: thEnConverterService
  ) {}
  /**
   *load method
   *
   * @memberof PatientMergeComponent
   */
  ngOnInit(): void {
    this.langaugeValue=localStorage.getItem("lan");
    this.initSearchFilter();
    this.getReasonList();
    this.onChanges();
  }
  onChanges() {
    this.subscriptionList.add(
      this.reasonSearch.valueChanges.subscribe((value) => {
        this.reasonSample = this.reasonList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }
  public initSearchFilter() {
    this.subscriptionList.add(
      this.searchHead
        .getTypeSearch(OPD_API_URL.M_PAT_MERGE_SEARCH)
        .subscribe((data: any) => {
          this.searchHead.updateSearchHeader(data);
        })
    );

    this.subscriptionList.add(
      this.searchService.getResult.subscribe((result) => {
        this.searchCriteria = this.searchHead.SetPatientSearch(result);
        this.patientList = null;
        this.refreshTime = new Date().toString();
        this.hidePatientSearch = false;
      })
    );

    let quickSearch = this.searchService.getElasticSearch.subscribe(quickSearch => {
      let result = {mrn: quickSearch};
      this.searchCriteria = this.searchHead.SetPatientSearch(result);
      this.patientList = null;
      this.refreshTime = new Date().toString();
      this.hidePatientSearch = false;
    });
    this.subscriptionList.add(quickSearch);
  }
  /*Destroy method
   *
   * @memberof PatientRegistrationComponent
   */
  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }
  /**
   *patientselected row
   *
   * @param {*} patient
   * @memberof PatientMergeComponent
   */
  patientOnSelect(patient) {
    if (patient.id) {
      this.getPatientPrimaryData(patient);
    }
  }
  /**
   *get patient primary Data
   *
   * @param {*} patient
   * @memberof PatientMergeComponent
   */
  getPatientPrimaryData(patient) {
    this.selectedPatient = patient;
    this.patientInfoDisplay =
      patient.mrn +
      " / " +
      (patient.patientNameLangBase || patient.fullName) +
      " / " +
      (patient.gender ? patient.gender : "Unknown") +
      " / " +
      (patient.dateOfBirth ? (this.langaugeValue === Langauge.TH ? this.thConvertService.convertToThaiFullDateWithOutTime(patient.dateOfBirth) : this.datepipe.transform(patient.dateOfBirth, "dd-MM-yyyy")) : "")
  }
  /**
   *add secondary Details
   *
   * @memberof PatientMergeComponent
   */ 
  addSecondaryDetails() {
    if (this.selectedPatient) {
      const dialogRef = this.dialog.open(PatientBlockAddComponent, {
        width: "800px",
        data: { isMergePatient: true,element:this.selectedPatient },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe((result) => {
          let alldata = this.mergeService.patientMergeModel(result);
          // alldata.dob = this.datepipe.transform(alldata.dob, "dd/MM/yyyy");
          let list =  this.dataSource.data;
          list.push(alldata);
          this.dataSource = new MatTableDataSource<any>(list);
          this.initSearchFilter();
        })
      );
    } else {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.pleaseselectprimarypatient"),
        this.langService.get("CommonAppoinment.warning"),
        {
          duration: 2000,
        }
      );
    }
  }
  /**
   *It is the source of Reason data
   *
   * @memberof PatientRegistrationComponent
   */
  getReasonList() {
    this.appBaseService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.M_REASON_MASTER_QUERY_NEW+"MERG",true)
      .subscribe((res) => {
        res.forEach((element) => {
          this.reasonSample.push(element);
        });
        this.reasonList=this.reasonSample;
      });
  }
  /**
   *remove pateint from list
   *
   * @param {*} index
   * @memberof PatientMergeComponent
   */
  removePatient(element) {
    const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
       width: "20%",
          data: { displayText: "Are you sure you want to delete the selected records?" },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
          const selectedIndex = this.dataSource.data.findIndex(
        item => item === element
      );

      console.log("Selected index:", selectedIndex);

      if (selectedIndex !== -1) {
        this.dataSource.data.splice(selectedIndex, 1);
      }

      this.dataSource.data = [...this.dataSource.data];

      }
    })
   }
    // this.alldata.splice(index, 1);
    // this.dataSource = new MatTableDataSource<any>(this.alldata);
  
  /**
   *merge patient
   *
   * @memberof PatientMergeComponent
   */
  mergePatient() {
    var secondaryId = this.dataSource.filteredData.map((t) => t.Id);
    if (this.dataSource.filteredData.length != 0 && this.selectedPatient) {
      if (this.reason) {
      const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
       width: "20%",
          data: { displayText: "Are you sure you want to merge the selected patient records?" },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result && result.confirm == "yes") {
        let resReason = this.reasonSample.find((s) => s.code == this.reason);
        let requestObject = {
          primaryPatientId: this.selectedPatient.id,
          secondaryPatientIdList: secondaryId,
          remarks: this.remarks,
          reason: this.reason
            ? this.langService.createObjectList(resReason)
            : null,
        };

        this.subscriptionList.add(
          this.generalApiService
            .postTypeApi(
              OPD_API_URL.OPD_SERVICE,
              OPD_API_URL.OPD_MERGE,
              requestObject
            )
            .subscribe((response: any) => {
              if (response) {
                this.snackBar.open(
                  this.langService.get(
                    "CommonAppoinment.patientmergedsuccessfully"
                  ),
                  this.langService.get("CommonAppoinment.success"),
                  {
                    duration: 2000,
                  }
                );
                this.clearData();
              }
            })
        );
      }
     })
     } else {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.pleaseselectreaon"),
          this.langService.get("CommonAppoinment.warning"),
          {
            duration: 2000,
          }
        );
      }
    } else {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.pleaseselectpatient"),
        this.langService.get("CommonAppoinment.warning"),
        {
          duration: 2000,
        }
      );
    }
  }
  /**
   *clear Data
   *
   * @memberof PatientMergeComponent
   */
  clearData() {
    this.selectedPatient = {};
    this.alldata = [];
    this.patientInfoDisplay = "";
    this.reason = null;
    this.remarks = "";
    this.dataSource = new MatTableDataSource<any>();
  }
}
